module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Detalhes do histórico - " + _vm._s(_vm.log.identifier))]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_c('div', {
    staticClass: "l-row code-container"
  }, [_c('div', {
    staticClass: "l-col-10@md"
  }, [_c('vue-json-pretty', {
    attrs: {
      "data": _vm.log.privateData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textRight"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (JSON.stringify(_vm.log.privateData)),
      expression: "JSON.stringify(log.privateData)",
      arg: "copy"
    }],
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Fechar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d98c0a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LogModal.vue
// module id = 3206
// module chunks = 0